import React, { useEffect } from 'react';
import { Modal, Table, TableColumnsType } from 'antd';
import { StreamKeyKappi } from '../../types';
import { useGetStreamKeysAdmin } from '../../hooks/useGetStreamKeysAdmin';
import { RollbackOutlined } from '@ant-design/icons';

interface StreamKeyModalProps {
  open: boolean;
  handleClose: () => void;
  userId: string;
  accessToken: string;
}

function StreamKeyModal(props: StreamKeyModalProps) {
  const [loading, setLoading] = React.useState<boolean>(true);
  const streamKeys = useGetStreamKeysAdmin(props.userId, props.accessToken, [props.accessToken, props.userId]);

  useEffect(() => {
    setLoading(false);
  }, [streamKeys]);

  const streamKeyColumns: TableColumnsType<StreamKeyKappi> = [
    {
      title: 'User Id',
      dataIndex: 'user_id',
      key: 'user_id',
    },
    {
      title: 'Public Id',
      dataIndex: 'public_id',
      key: 'public_id',
    },
    {
      title: 'Key',
      dataIndex: 'key',
      key: 'key',
    },
    {
      title: 'Created at',
      dataIndex: 'created_at',
      key: 'created_at',
    },
    {
      title: 'Last used at',
      dataIndex: 'last_used_at',
      key: 'last_used_at',
    },
  ];

  return (
    <Modal
      title='Stream keys'
      open={props.open}
      onOk={props.handleClose}
      cancelButtonProps={{ style: { display: 'none' } }}
      okButtonProps={{ icon: <RollbackOutlined /> }}
      okText='Hide'
      width={'80%'}
      closable={false}
    >
      <Table
        columns={streamKeyColumns}
        dataSource={streamKeys}
        rowKey={'key'}
        size='medium'
        locale={{ emptyText: <span>No stream keys found!</span> }}
        loading={loading}
      />
    </Modal>
  );
}

export default StreamKeyModal;
